import { render, staticRenderFns } from "./PropertyCreateForm.vue?vue&type=template&id=bba3b3bc&scoped=true"
import script from "./PropertyCreateForm.vue?vue&type=script&lang=js"
export * from "./PropertyCreateForm.vue?vue&type=script&lang=js"
import style0 from "./PropertyCreateForm.vue?vue&type=style&index=0&id=bba3b3bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3b3bc",
  null
  
)

export default component.exports